<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <tickets-table></tickets-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import TicketsTable from './TicketsTable.vue'

  export default {
    name: 'scratchcard-tickets',
    components: {TicketsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/scratchcard/tickets/Tickets.vue